import { useContext, useEffect, useState } from 'react';
import style from './VendorSalesSettlement.module.css';
import { requester } from 'App';
import {
    combineDuplicates,
    filterDataByThisMonth,
    filterDataByThisWeek,
    filterDataByThisYear,
    filterDataByToday,
    getDailySales,
    getTotalAmount,
} from 'routes/vendorRe/commonFn/vendorPurchaseOrder';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import depthMove from 'routes/vendorRe/images/depth_move_icon.png';
import P from 'routes/vendorRe/containers/commons/P';
import LineChart from 'routes/vendorRe/components/LineChart';
import SettlementAmount from './settlementComp/SettlementAmount';
import SettlementStatus from './settlementComp/SettlementStatus';
import SettlementBest from './settlementComp/SettlementBest';
import SettlementStat from './settlementComp/SettlementStat';
import Center from 'layouts/wrapper/Center';
import { AuthContext } from 'providers/AuthProvider';
import VendorCalc from 'routes/vendorRe/pages/VendorCalc';
import { useNavigate } from 'react-router-dom';
import styles from './VendorSalesSettlement.module.css';

function VendorSalesSettlement() {
    const [isMounted, setMounted] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [verificationStats, setVerificationStats] = useState([]);
    const { userName } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            let data = {};
            requester.getVendorTotalAmount(data, result => {
                if (result.data) {
                    setTotalAmount(result.data.amount);
                }
            });
            requester.vendorAdultVerificationStats(data, result => {
                if (result.data) {
                    setVerificationStats(result.data);
                    console.log(result.data);
                }
            })
        }
    }, [isMounted]);

    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={20}>
                    <FlexChild width={"95%"}>
                        <Center width={'100%'} textAlign={'left'}>
                            <P weight={'bold'} size={40}>
                                정산관리
                            </P>
                        </Center>
                    </FlexChild>
                    <FlexChild width={"95%"}>
                        <HorizontalFlex
                            gap={20}
                        >
                            <FlexChild>
                                <HorizontalFlex gap={20} alignItems={'flex-start'}>
                                    <FlexChild> 
                                        {/* 매출 현황 */}
                                        <SettlementStatus />
                                    </FlexChild>
                                    <FlexChild>
                                        <VendorCalc web />
                                    </FlexChild>
                                    <FlexChild>
                                        <div className={styles.verificationSection}>
                                            <div className={styles.statsHeader}>
                                                <h2 className={styles.statsTitle}>성인인증 통계</h2>
                                                <span 
                                                    className={styles.moreLink}
                                                    onClick={() => navigate('/vendor/verificationStats')}
                                                >
                                                    더보기 {'>'}
                                                </span>
                                            </div>
                                            {Array.isArray(verificationStats) && verificationStats.slice(0, 3).map((store) => (
                                                <div key={store.storeCode} className={styles.storeCard}>
                                                    <div className={styles.storeName}>{store.storeName}</div>
                                                    <div className={styles.storeStats}>
                                                        <div className={styles.statItem}>
                                                            <div className={styles.statLabel}>총 시도</div>
                                                            <div className={styles.statValue}>
                                                                {store.totalCount}
                                                            </div>
                                                        </div>
                                                        <div className={styles.statItem}>
                                                            <div className={styles.statLabel}>PASS인증</div>
                                                            <div className={`${styles.statValue} ${styles.green}`}>
                                                                {store.passCount}
                                                            </div>
                                                        </div>
                                                        <div className={styles.statItem}>
                                                            <div className={styles.statLabel}>SMS인증</div>
                                                            <div className={`${styles.statValue} ${styles.blue}`}>
                                                                {store.smsCount}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild width={"95%"}>
                        {/* 주간 판매량 BEST 3 */}
                        <SettlementBest />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default VendorSalesSettlement;
